var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { combineReducers } from "redux";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import userAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import reducer from "./views/reducers/ConfigEditorReducer.js";
import reducer$1 from "./views/reducers/ConfigSectionReducer.js";
import reducer$2 from "./views/reducers/ConfigPathReducer.js";
import reducer$3 from "./views/reducers/ConfigSnapshotReducer.js";
import GlobalConfigReducer from "@ane/exp-data/lib/globalConfig/GlobalConfigReducer";
import RouteUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
const moduleReducer = __spreadValues(__spreadValues(__spreadValues(__spreadValues({
  adminModule: combineReducers({
    configEditor: reducer,
    configSections: reducer$1,
    configPaths: reducer$2,
    configSnapshots: reducer$3
  }),
  globalConfig: GlobalConfigReducer
}, RouteUpdateReducer), getWorkspaceReducersMapObject), currentUserDetailsReducersMapObject), userAccessReducersMapObject);
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
